// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Overlay */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

/* Modal Box */
.role-modal {
  background: linear-gradient(180deg, #0f172a, #020617);
  width: 420px;
  max-width: 90vw;
  padding: 26px;
  border-radius: 16px;
  box-shadow: 0 25px 60px rgba(0,0,0,0.5);
  animation: popIn 0.25s ease;
}

@keyframes popIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Title */
.modal-title {
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  color: #f8fafc;
  margin-bottom: 20px;
}

/* Form */
.form-group {
  margin-bottom: 18px;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #cbd5f5;
}

.form-group input {
  width: 100%;
  padding: 10px 14px;
  border-radius: 12px;
  border: 1px solid #1e293b;
  font-size: 14px;
}

.form-group input::placeholder {
  color: #64748b;
}

.form-group input:focus {
  outline: none;
  border-color: #facc15;
  box-shadow: 0 0 0 2px rgba(250, 204, 21, 0.25);
}

/* Actions */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 22px;
}

.btn-cancel {
  padding: 8px 16px;
  border-radius: 12px;
  border: 1px solid #1e293b;
  background: transparent;
  color: #cbd5f5;
  font-weight: 600;
  cursor: pointer;
}

.btn-cancel:hover {
  background: #020617;
}

.btn-primary {
  padding: 8px 18px;
  border-radius: 12px;
  border: none;
  background: #facc15;
  color: #020617;
  font-weight: 700;
  cursor: pointer;
}

.btn-primary:hover {
  background: #fde047;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Roles/AddRole/AddRole.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA,cAAc;AACd;EACE,qDAAqD;EACrD,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* Overlay */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.65);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 999;\n}\n\n/* Modal Box */\n.role-modal {\n  background: linear-gradient(180deg, #0f172a, #020617);\n  width: 420px;\n  max-width: 90vw;\n  padding: 26px;\n  border-radius: 16px;\n  box-shadow: 0 25px 60px rgba(0,0,0,0.5);\n  animation: popIn 0.25s ease;\n}\n\n@keyframes popIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Title */\n.modal-title {\n  text-align: center;\n  font-size: 20px;\n  font-weight: 700;\n  color: #f8fafc;\n  margin-bottom: 20px;\n}\n\n/* Form */\n.form-group {\n  margin-bottom: 18px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #cbd5f5;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 10px 14px;\n  border-radius: 12px;\n  border: 1px solid #1e293b;\n  font-size: 14px;\n}\n\n.form-group input::placeholder {\n  color: #64748b;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #facc15;\n  box-shadow: 0 0 0 2px rgba(250, 204, 21, 0.25);\n}\n\n/* Actions */\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 22px;\n}\n\n.btn-cancel {\n  padding: 8px 16px;\n  border-radius: 12px;\n  border: 1px solid #1e293b;\n  background: transparent;\n  color: #cbd5f5;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.btn-cancel:hover {\n  background: #020617;\n}\n\n.btn-primary {\n  padding: 8px 18px;\n  border-radius: 12px;\n  border: none;\n  background: #facc15;\n  color: #020617;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.btn-primary:hover {\n  background: #fde047;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
